// extracted by mini-css-extract-plugin
export var alignBaseline = "_v-9";
export var alignCenter = "_v-5";
export var alignFlexEnd = "_v-7";
export var alignFlexStart = "_v-6";
export var alignSelfBaseline = "_v-e";
export var alignSelfCenter = "_v-a";
export var alignSelfFlexEnd = "_v-c";
export var alignSelfFlexStart = "_v-b";
export var alignSelfStretch = "_v-d";
export var alignStretch = "_v-8";
export var column = "_v-2";
export var columnReverse = "_v-4";
export var flex = "_v-0";
export var justifyCenter = "_v-f";
export var justifyFlexEnd = "_v-h";
export var justifyFlexStart = "_v-g";
export var justifySpaceAround = "_v-j";
export var justifySpaceBetween = "_v-i";
export var justifySpaceEvenly = "_v-k";
export var row = "_v-1";
export var rowReverse = "_v-3";
export var wrapNowrap = "_v-m";
export var wrapWrap = "_v-l";
export var wrapWrapReverse = "_v-n";